import { Flex } from "@aircall/tractor";

import { EvaluationQuestionSummaryRating } from "@/components/EvaluationQuestionSummaryRating/EvaluationQuestionSummaryRating";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <EvaluationQuestionSummaryRating
        value="YES"
        maximumPoints={10}
        points={10}
      />
      <EvaluationQuestionSummaryRating
        value="NO"
        maximumPoints={10}
        points={0}
      />
    </Flex>
  );
}

function ScaleVariants() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <EvaluationQuestionSummaryRating
        value="EXCELLENT"
        maximumPoints={5}
        points={5}
      />
      <EvaluationQuestionSummaryRating
        value="GOOD"
        maximumPoints={5}
        points={4}
      />
      <EvaluationQuestionSummaryRating
        value="FAIR"
        maximumPoints={5}
        points={3}
      />
      <EvaluationQuestionSummaryRating
        value="POOR"
        maximumPoints={5}
        points={2}
      />
      <EvaluationQuestionSummaryRating
        value="VERY_POOR"
        maximumPoints={5}
        points={1}
      />
    </Flex>
  );
}

function EdgeCases() {
  return (
    <Flex gap="s" flexWrap="wrap">
      {/* Disabled state */}
      <EvaluationQuestionSummaryRating disabled maximumPoints={10} />

      {/* No points provided */}
      <EvaluationQuestionSummaryRating value="YES" maximumPoints={10} />

      {/* Zero points */}
      <EvaluationQuestionSummaryRating
        value="NO"
        maximumPoints={10}
        points={0}
      />

      {/* High maximum points */}
      <EvaluationQuestionSummaryRating
        value="EXCELLENT"
        maximumPoints={100}
        points={95}
      />
    </Flex>
  );
}

function DifferentPointScales() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <EvaluationQuestionSummaryRating
        value="EXCELLENT"
        maximumPoints={1}
        points={1}
      />
      <EvaluationQuestionSummaryRating
        value="GOOD"
        maximumPoints={3}
        points={2}
      />
      <EvaluationQuestionSummaryRating
        value="FAIR"
        maximumPoints={20}
        points={12}
      />
      <EvaluationQuestionSummaryRating
        value="POOR"
        maximumPoints={50}
        points={15}
      />
    </Flex>
  );
}

export function PlaygroundEvaluationQuestionSummaryRating() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Basic Usage (Yes/No)
        </PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Scale Variants</PlaygroundSubSectionTitle>
        <ScaleVariants />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Different Point Scales
        </PlaygroundSubSectionTitle>
        <DifferentPointScales />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Edge Cases</PlaygroundSubSectionTitle>
        <EdgeCases />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
